import React from 'react';

import {TimeWindow} from 'src/lib/api/eval';
import * as tw from 'src/lib/tailwindClasses';

const WINDOWS: {value: TimeWindow; label: string}[] = [
  {value: '10d', label: '10d'},
  {value: '30d', label: '30d'},
  {value: '90d', label: '90d'},
  {value: '180d', label: '180d'},
  {value: '365d', label: '365d'},
  {value: 'all', label: 'All'},
];

export default function TimeWindowSelector({
  value,
  onChange,
}: {
  value: TimeWindow;
  onChange: (window: TimeWindow) => void;
}) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value as TimeWindow)}
      className={`${tw.select} w-28`}
      aria-label="Time window"
    >
      {WINDOWS.map((w) => (
        <option key={w.value} value={w.value}>
          {w.label}
        </option>
      ))}
    </select>
  );
}
